<template>
  <div class="send-note-email">
    <div v-if="can_send_email" class="mb-7 ml-2">
      <CheckboxInput
        class="send-note-email-checkbox"
        v-model="isNotify"
        :label="`Notify ${isUserLabel}`"
      />
      <span
        v-if="userContent === ''"
        class="send-note-email-description"
      >
        The <span class="is-user-label">{{isUserLabel}}</span> will be notified via email
      </span>
      <span
        v-else
        class="send-note-email-description"
      >
        {{ userContent }}
      </span>
    </div>
    <div class="notification-warning mb-7 ml-3" v-else>
      <v-img
        class="notify-icon"
        :src="require('@components/assets/notify-outer.svg')"
        contain
        width="30"
        height="30"
      />
      <div class="text-content">
        <span class="main-text">Employee cannot be notified</span>
        <span class="sub-text">because it does not have access</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import CheckboxInput from "@components/Checkbox/CheckboxInput.vue";

const emit = defineEmits(['update:notify']);

const propsDef = defineProps({
  can_send_email: {
    type: Boolean,
    default: false,
  },
  notify: {
    type: Boolean,
    default: false,
  },
  is_employee: {
    type: Boolean,
    default: false,
  },
  userLabel: {
    type: String,
    default: "",
  },
  userContent: {
    type: String,
    default: "",
  }
});

const isNotify = ref(propsDef.notify);
const isEmpoyee = ref(propsDef.is_employee);
const isUserLabel = ref(propsDef.userLabel);

watch(() => propsDef.notify, (newValue) => {
  isNotify.value = newValue;
});

watch(isNotify, (newValue) => {
  emit('update:notify', newValue);
});

watch(() => propsDef.is_employee, (newValue) => {
  isEmpoyee.value = newValue;
  if (isEmpoyee.value === true) {
    isUserLabel.value = "Employee";
  } else {
    isUserLabel.value = "User";
  }
});

</script>

<style scoped>
::v-deep .send-note-email .send-note-email-checkbox .icon-check .v-btn {
  width: 24px !important;
}
::v-deep .v-input__slot {
  height: 44px !important;
}
.send-note-email .send-note-email-description {
  color: #475467;
  font-size: 14px;
  position: relative;
  top: -10px;
  left: 35px;
}
.send-note-email .notification-warning {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.send-note-email .notify-icon {
  margin-top: 2px;
  position: absolute;
}
.send-note-email .text-content {
  display: flex;
  flex-direction: column;
  position: relative;
  left: 38px;
  top: 5px;
}
.send-note-email .main-text {
  font-family: Inter;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: #344054;
}
.send-note-email .sub-text {
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: #475467;
}
::v-deep .send-note-email-checkbox span {
  margin-left: 0px !important;
}
.send-note-email .is-user-label {
  text-transform: lowercase;
}
</style>
